import PlatformAnnouncementsAPI from '../../../api/platformAnnouncements';

// Resolves dynamic placeholders in action_url
// Supported: {{account_id}} → replaced with the current account ID
function resolveActionUrl(announcement, rootGetters) {
  if (!announcement?.action_url) return announcement;

  const accountId = rootGetters.getCurrentAccountId;
  if (!accountId) return announcement;

  return {
    ...announcement,
    action_url: announcement.action_url.replace(
      /\{\{account_id\}\}/g,
      String(accountId)
    ),
  };
}

export const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await PlatformAnnouncementsAPI.get();
      commit('SET_ANNOUNCEMENTS', data.data || []);
      commit('SET_META', { unreadCount: data.meta?.unread_count || 0 });
    } catch (error) {
      // Silently fail — announcements are non-critical
      // eslint-disable-next-line no-console
      console.warn('[PlatformAnnouncements] Failed to fetch:', error);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async dismiss({ commit }, announcementId) {
    try {
      await PlatformAnnouncementsAPI.dismiss(announcementId);
      commit('REMOVE_ANNOUNCEMENT', announcementId);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[PlatformAnnouncements] Failed to dismiss:', error);
      throw error;
    }
  },

  addAnnouncement({ commit, rootGetters }, announcement) {
    commit('ADD_ANNOUNCEMENT', resolveActionUrl(announcement, rootGetters));
  },

  updateAnnouncement({ commit, rootGetters }, announcement) {
    commit('UPDATE_ANNOUNCEMENT', resolveActionUrl(announcement, rootGetters));
  },

  // v6.4.50: Handle real-time deletion/deactivation via WebSocket
  removeAnnouncement({ commit }, announcementId) {
    commit('REMOVE_ANNOUNCEMENT', announcementId);
  },
};

